import { render, staticRenderFns } from "./baseaktarim.vue?vue&type=template&id=5daca6c8&"
import script from "./baseaktarim.vue?vue&type=script&lang=js&"
export * from "./baseaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports